import axios, { AxiosResponse } from "axios";
import { GetPaidInitialData } from "types/get_paid";
import { sanitizeGetPaidData } from "helpers/get_paid";

export async function getGetPaidInitialData() {
  const response = await axios.get<GetPaidInitialData[]>(
    `/tenant/integrations/tahseel.json`
  );
  const data = sanitizeGetPaidData(response.data);
  return data;
}

export async function postGetPaidForm(
  formData: FormData
): Promise<AxiosResponse<any>> {
  console.log("formData", formData);
  const response = await axios.post(
    `/tenant/integrations/install_qpay`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "text/javascript",
      },
    }
  );
  return response.data as AxiosResponse<any>;
}
